import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { checkBonusPromoAllowed, checkDomainsAllowed } from 'features/bonusProgram/data';
import { checkPaymentsAllowed } from 'features/finance/data';

import allUsers from './img/allUsers.svg';
import agents from './img/agents.svg';
import players from './img/players.svg';
import createAgent from './img/createAgent.svg';
import createPlayer from './img/createPlayer.svg';
import generalReport from './img/generalReport.svg';
import depositsAndWithdrawals from './img/depositsAndWithdrawals.svg';
import playerHistory from './img/playerHistory.svg';
import playerAndAgentDetail from './img/playerAndAgentDetail.svg';
import sportBets from './img/sportBets.svg';
import myDebtAccount from './img/myDebtAccount.svg';
import payments from './img/payments.svg';
// import howToStart from './img/howToStart.svg';
import domainsSVG from './img/domains.svg';

import allUsersWhite from './img/white/allUsers.svg';
import agentsWhite from './img/white/agents.svg';

import playersWhite from './img/white/players.svg';
import createAgentWhite from './img/white/createAgent.svg';
import createPlayerWhite from './img/white/createPlayer.svg';
import generalReportWhite from './img/white/generalReport.svg';
import depositsAndWithdrawalsWhite from './img/white/depositsAndWithdrawals.svg';
import playerHistoryWhite from './img/white/playerHistory.svg';
import playerAndAgentDetailWhite from './img/white/playerAndAgentDetail.svg';
import sportBetsWhite from './img/white/sportBets.svg';
import myDebtAccountWhite from './img/white/myDebtAccount.svg';
import paymentsWhite from './img/white/payments.svg';
// import howToStartWhite from './img/white/howToStart.svg';
import statistic from './img/statistic.svg';
import statisticWhite from './img/white/statistic.svg';
import rankingSVG from './img/ranking.svg';
import rankingWhiteSVG from './img/white/ranking.svg';
import playerDepositsIMG from './img/playerDeposits.svg';
import playerDepositsWhiteIMG from './img/white/playerDeposits.svg';
import requestHistorySVG from './img/requestHistory.svg';
import requestHistoryWhiteSVG from './img/white/requestHistory.svg';
import custom from './img/custom.svg';
import customWhite from './img/white/custom.svg';
import customRequests from './img/customRequests.svg';
import customRequestsWhite from './img/white/customRequests.svg';

import giftRequestsSVG from './img/gift-requests.svg';
import giftRequestsWhiteSVG from './img/white/gift-requests.svg';
import giftManagementSVG from './img/gift-management.svg';
import giftManagementWhiteSVG from './img/white/gift-management.svg';
import cashbackCreationSVG from './img/cashbackCreation.svg';
import cashbackCreationWhiteSVG from './img/white/cashbackCreation.svg';
import createPromotionsSVG from './img/createPromotions.svg';
import createPromotionsWhiteSVG from './img/white/createPromotions.svg';
// import feedbackSVG from './img/feedback.svg';
import domainsWhiteSVG from './img/white/domains.svg';

import { rankTypes } from 'features/ranking/data';

export const useSidebarMenu = () => {
  const { role, semiAutoWithdrawalEnabled, arePromotionsAvailable, canCreateOnlyPlayer } = useSelector(state => state.auth);
  const { myRank } = useSelector(state => state.rankings);
  const { playerDeposits } = useSelector(state => state.reports);

  const restrictedRanks = [
    // rankTypes.providerGold
  ];
  const isRestrictedRank = restrictedRanks.includes(myRank?.rank);

  const result = useMemo(
    () =>
      [
        {
          title: 'bonusProgram',
          route: '#',
          routeForActiveTab: '',
          level: 0,
          forbiddenRoles: [],
          // checkAccess: checkBonusPromoAllowed,
          children: [
            {
              title: 'requestForGift',
              route: '/bonus-promo/requests',
              routeForActiveTab: '/bonus-promo/requests',
              img: giftRequestsSVG,
              level: 1,
              whiteImg: giftRequestsWhiteSVG,
              checkAccess: checkBonusPromoAllowed,
              forbiddenRoles: [],
            },
            {
              title: 'giftManagement',
              route: '/bonus-promo/management',
              routeForActiveTab: '/bonus-promo/management',
              img: giftManagementSVG,
              level: 1,
              whiteImg: giftManagementWhiteSVG,
              checkAccess: checkBonusPromoAllowed,
              withParams: true,
              forbiddenRoles: [],
            },
          ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        },
        {
          title: 'myStatistic',
          route: '/statistic',
          routeForActiveTab: '/statistic',
          img: statistic,
          level: 1,
          whiteImg: statisticWhite,
          forbiddenRoles: [],
        },
        {
          title: 'ranking',
          route: '/ranking',
          routeForActiveTab: '/ranking',
          level: 1,
          img: rankingSVG,
          whiteImg: rankingWhiteSVG,
          forbiddenRoles: [6],
          // blocked: myRank?.rank === rankTypes.providerGold,
        },
        // {
        //   title: 'pragmaticTournament',
        //   route: '/pragmatic-tournament',
        //   routeForActiveTab: '/pragmatic-tournament',
        //   level: 1,
        //   img: rankingSVG,
        //   whiteImg: rankingWhiteSVG,
        //   forbiddenRoles: [6],
        // },
        // {
        //   title: 'rubyPlayTournamentTitle',
        //   route: '/ruby-play-tournament',
        //   routeForActiveTab: '/ruby-play-tournament',
        //   level: 1,
        //   img: rankingSVG,
        //   whiteImg: rankingWhiteSVG,
        //   forbiddenRoles: [],
        // },
        // {
        //   title: 'netentTournamentTitle',
        //   route: '/netent-tournament',
        //   routeForActiveTab: '/netent-tournament',
        //   level: 1,
        //   img: rankingSVG,
        //   whiteImg: rankingWhiteSVG,
        //   forbiddenRoles: [],
        // },
        {
          title: 'users',
          route: '#',
          routeForActiveTab: '',
          level: 0,
          forbiddenRoles: [],
          children: [
            {
              title: 'allUsers',
              route: '/users/all',
              routeForActiveTab: '/users/all',
              img: allUsers,
              level: 1,
              whiteImg: allUsersWhite,
              forbiddenRoles: [],
            },
            {
              title: 'agents',
              route: '/users/agents',
              routeForActiveTab: '/users/agents',
              img: agents,
              level: 1,
              whiteImg: agentsWhite,
              forbiddenRoles: [],
              checkAccess: authData => !authData.canCreateOnlyPlayer,
            },
            {
              title: 'players',
              route: '/users/players',
              routeForActiveTab: '/users/players',
              img: players,
              level: 1,
              whiteImg: playersWhite,
              forbiddenRoles: [],
            },
            {
              title: 'createAgent',
              route: '/user/create-agent',
              routeForActiveTab: '/user/create-agent',
              img: createAgent,
              level: 1,
              whiteImg: createAgentWhite,
              forbiddenRoles: [],
              checkAccess: authData => !authData.canCreateOnlyPlayer,
            },
            {
              title: 'createPlayer',
              route: '/user/create-player',
              routeForActiveTab: '/user/create-player',
              img: createPlayer,
              level: 1,
              whiteImg: createPlayerWhite,
              forbiddenRoles: [],
            },
          ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        },
        {
          title: 'financialReports',
          route: '#',
          routeForActiveTab: '',
          level: 0,
          forbiddenRoles: [],
          children: [
            {
              title: 'generalReport',
              img: generalReport,
              route: '/reports/financial-reports/general',
              routeForActiveTab: '/reports/financial-reports/general',
              level: 1,
              whiteImg: generalReportWhite,
              forbiddenRoles: [],
            },
            {
              title: 'depositsAndWithdrawals',
              img: depositsAndWithdrawals,
              route: '/reports/financial-reports/cash',
              routeForActiveTab: '/reports/financial-reports/cash',
              level: 1,
              whiteImg: depositsAndWithdrawalsWhite,
              forbiddenRoles: [],
            },
            {
              title: 'playerDeposits',
              img: playerDepositsIMG,
              route: '/reports/financial-reports/player-deposits',
              routeForActiveTab: '/reports/financial-reports/player-deposits',
              level: 1,
              whiteImg: playerDepositsWhiteIMG,
              /* blocked: !semiAutoWithdrawalEnabled, */
              count: playerDeposits.count,
            },
            {
              title: 'requestHistory',
              img: requestHistorySVG,
              whiteImg: requestHistoryWhiteSVG,
              route: '/reports/financial-reports/request-history',
              routeForActiveTab: '/reports/financial-reports/request-history',
              level: 1,
              blocked: !semiAutoWithdrawalEnabled,
            },
          ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        },
        {
          title: 'playerReports',
          route: '#',
          routeForActiveTab: '',
          level: 0,
          forbiddenRoles: [],
          children: [
            {
              title: 'playerHistory',
              img: playerHistory,
              route: '/reports/player-reports/player-history',
              routeForActiveTab: '/reports/player-reports/player-history',
              level: 1,
              whiteImg: playerHistoryWhite,
              forbiddenRoles: [],
            },
            {
              title: canCreateOnlyPlayer ? 'detailByPlayer' : 'playerAndAgentDetail',
              img: playerAndAgentDetail,
              route: '/reports/player-reports/detail-by-player',
              routeForActiveTab: '/reports/player-reports/detail-by-player',
              level: 1,
              whiteImg: playerAndAgentDetailWhite,
              forbiddenRoles: [],
              checkAccess: authData => authData.canCreateOnlyPlayer,
            },
            {
              title: 'sportBets',
              img: sportBets,
              route: '/reports/player-reports/sport-bets',
              routeForActiveTab: '/reports/player-reports/sport-bets',
              level: 1,
              whiteImg: sportBetsWhite,
              forbiddenRoles: [],
            },
          ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        },
        {
          title: 'finance',
          route: '#',
          routeForActiveTab: '',
          level: 0,
          forbiddenRoles: [],
          children: [
            {
              title: 'myDebtAccount',
              img: myDebtAccount,
              route: '/finance/my-debt-account',
              routeForActiveTab: '/finance/my-debt-account',
              level: 1,
              whiteImg: myDebtAccountWhite,
              forbiddenRoles: [],
            },
            {
              title: 'payments',
              img: payments,
              route: '/finance/payments',
              routeForActiveTab: '/finance/payments',
              level: 1,
              whiteImg: paymentsWhite,
              forbiddenRoles: [],
              checkAccess: checkPaymentsAllowed,
            },
            // {
            //   title: 'howToStart',
            //   img: howToStart,
            //   route: '/finance/how-to-start',
            //   routeForActiveTab: '/finance/how-to-start',
            //   level: 1,
            //   whiteImg: howToStartWhite,
            //   forbiddenRoles: [],
            // },
          ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        },
        // {
        //   title: 'programaDeBonificacion',
        //   route: '#',
        //   routeForActiveTab: '',
        //   level: 0,
        //   forbiddenRoles: [],
        //   children: [
        //     {
        //       title: 'contactLinkText',
        //       route: '#',
        //       routeForActiveTab: '',
        //       img: feedbackSVG,
        //       level: 1,
        //       whiteImg: feedbackWhiteSVG,
        //       isSpecialAction: true,
        //       forbiddenRoles: [],
        //     },
        //   ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        // },
        {
          title: 'creativeFunctionality',
          route: '#',
          routeForActiveTab: '',
          level: 0,
          forbiddenRoles: [],
          children: [
            {
              title: 'domains',
              route: '/domains',
              routeForActiveTab: '/domains',
              level: 1,
              img: domainsSVG,
              whiteImg: domainsWhiteSVG,
              forbiddenRoles: [6],
              checkAccess: checkDomainsAllowed,
            },
            {
              title: 'cashbackCreation',
              route: '/creative/cashback-creation',
              routeForActiveTab: '/creative/cashback-creation',
              img: cashbackCreationSVG,
              level: 1,
              whiteImg: cashbackCreationWhiteSVG,
              forbiddenRoles: [],
            },
            {
              title: 'custom',
              img: custom,
              route: '/creative-functionality/custom',
              routeForActiveTab: '/creative-functionality/custom',
              level: 1,
              whiteImg: customWhite,
              forbiddenRoles: [],
            },
            {
              title: 'customRequests',
              img: customRequests,
              route: '/creative-functionality/custom-requests',
              routeForActiveTab: '/creative-functionality/custom-requests',
              level: 1,
              whiteImg: customRequestsWhite,
              forbiddenRoles: [],
            },
          ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        },
        {
          title: 'programaDeBonificacion',
          route: '#',
          routeForActiveTab: '',
          level: 0,
          forbiddenRoles: [],
          blocked: !arePromotionsAvailable,
          children: [
            {
              title: 'createPromotions',
              route: '/bonus-promo/promotions',
              routeForActiveTab: '/bonus-promo/promotions',
              img: createPromotionsSVG,
              level: 1,
              whiteImg: createPromotionsWhiteSVG,
              forbiddenRoles: [],
              withParams: true,
            },
          ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
        },
      ].filter(item => !(item?.forbiddenRoles?.includes(role) && isRestrictedRank) && !item?.blocked),
    [role, myRank, semiAutoWithdrawalEnabled, playerDeposits.count, arePromotionsAvailable],
  );

  return result;
};

// export const sidebarMenu = [
//   {
//     title: 'myStatistic',
//     route: '/statistic',
//     routeForActiveTab: '/statistic',
//     img: statistic,
//     level: 1,
//     whiteImg: statisticWhite,
//     forbiddenRoles: [],
//   },
//   {
//     title: 'ranking',
//     route: '/ranking',
//     routeForActiveTab: '/ranking',
//     level: 1,
//     img: rankingSVG,
//     whiteImg: rankingWhiteSVG,
//     forbiddenRoles: [6],
//   },
//   // {
//   //   title: 'pragmaticTournament',
//   //   route: '/pragmatic-tournament',
//   //   routeForActiveTab: '/pragmatic-tournament',
//   //   level: 1,
//   //   img: rankingSVG,
//   //   whiteImg: rankingWhiteSVG,
//   //   forbiddenRoles: [6],
//   // },
//   {
//     title: 'users',
//     route: '#',
//     routeForActiveTab: '',
//     level: 0,
//     forbiddenRoles: [],
//     children: [
//       {
//         title: 'allUsers',
//         route: '/users/all',
//         routeForActiveTab: '/users/all',
//         img: allUsers,
//         level: 1,
//         whiteImg: allUsersWhite,
//         forbiddenRoles: [],
//       },
//       {
//         title: 'agents',
//         route: '/users/agents',
//         routeForActiveTab: '/users/agents',
//         img: agents,
//         level: 1,
//         whiteImg: agentsWhite,
//         forbiddenRoles: [],
//       },
//       {
//         title: 'players',
//         route: '/users/players',
//         routeForActiveTab: '/users/players',
//         img: players,
//         level: 1,
//         whiteImg: playersWhite,
//         forbiddenRoles: [],
//       },
//       {
//         title: 'createAgent',
//         route: '/user/create-agent',
//         routeForActiveTab: '/user/create-agent',
//         img: createAgent,
//         level: 1,
//         whiteImg: createAgentWhite,
//         forbiddenRoles: [],
//       },
//       {
//         title: 'createPlayer',
//         route: '/user/create-player',
//         routeForActiveTab: '/user/create-player',
//         img: createPlayer,
//         level: 1,
//         whiteImg: createPlayerWhite,
//         forbiddenRoles: [],
//       },
//     ],
//   },
//   {
//     title: 'financialReports',
//     route: '#',
//     routeForActiveTab: '',
//     level: 0,
//     forbiddenRoles: [],
//     children: [
//       {
//         title: 'generalReport',
//         img: generalReport,
//         route: '/reports/financial-reports/general',
//         routeForActiveTab: '/reports/financial-reports/general',
//         level: 1,
//         whiteImg: generalReportWhite,
//         forbiddenRoles: [],
//       },
//       {
//         title: 'depositsAndWithdrawals',
//         img: depositsAndWithdrawals,
//         route: '/reports/financial-reports/cash',
//         routeForActiveTab: '/reports/financial-reports/cash',
//         level: 1,
//         whiteImg: depositsAndWithdrawalsWhite,
//         forbiddenRoles: [],
//       },
//     ],
//   },
//   {
//     title: 'playerReports',
//     route: '#',
//     routeForActiveTab: '',
//     level: 0,
//     forbiddenRoles: [],
//     children: [
//       {
//         title: 'playerHistory',
//         img: playerHistory,
//         route: '/reports/player-reports/player-history',
//         routeForActiveTab: '/reports/player-reports/player-history',
//         level: 1,
//         whiteImg: playerHistoryWhite,
//         forbiddenRoles: [],
//       },
//       // {
//       //   title: 'playerAndAgentDetail',
//       //   img: playerAndAgentDetail,
//       //   route: '/reports/player-reports/detail-by-player',
//       //   routeForActiveTab: '/reports/player-reports/detail-by-player',
//       //   level: 1,
//       //   whiteImg: playerAndAgentDetailWhite,
//       //   forbiddenRoles: [],
//       // },
//       {
//         title: 'sportBets',
//         img: sportBets,
//         route: '/reports/player-reports/sport-bets',
//         routeForActiveTab: '/reports/player-reports/sport-bets',
//         level: 1,
//         whiteImg: sportBetsWhite,
//         forbiddenRoles: [],
//       },
//     ],
//   },
//   {
//     title: 'finance',
//     route: '#',
//     routeForActiveTab: '',
//     level: 0,
//     forbiddenRoles: [],
//     children: [
//       {
//         title: 'myDebtAccount',
//         img: myDebtAccount,
//         route: '/finance/my-debt-account',
//         routeForActiveTab: '/finance/my-debt-account',
//         level: 1,
//         whiteImg: myDebtAccountWhite,
//         forbiddenRoles: [],
//       },
//       // {
//       //   title: 'howToStart',
//       //   img: howToStart,
//       //   route: '/finance/how-to-start',
//       //   routeForActiveTab: '/finance/how-to-start',
//       //   level: 1,
//       //   whiteImg: howToStartWhite,
//       //   forbiddenRoles: [],
//       // },
//     ],
//   },
//   {
//     title: 'creativeFunctionality',
//     route: '#',
//     routeForActiveTab: '',
//     level: 0,
//     forbiddenRoles: [],
//     checkAccess: checkCashbackAllowed,
//     children: [
//       {
//         title: 'cashbackCreation',
//         route: '/creative/cashback-creation',
//         routeForActiveTab: '/creative/cashback-creation',
//         img: cashbackCreationSVG,
//         level: 1,
//         whiteImg: cashbackCreationWhiteSVG,
//         forbiddenRoles: [],
//         checkAccess: checkCashbackAllowed,
//       },
//     ],
//   },
// ];

export const agentsItem = {
  title: 'agents',
  routeForActiveTab: '',
  img: allUsers,
  level: 0,
};
